import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import $ from 'jquery';
import Header from "./Header1.js";
import "../App.css"
import { Link, redirect } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser,faCreditCard,faEnvelope,faPhone,faBuilding,faFlag,faDollar } from '@fortawesome/free-solid-svg-icons'
import Button from "react-bootstrap/esm/Button.js";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import {formatDate, parseResponseJSON,dateDifference} from "./CommonFunctions";
import InputGroup from 'react-bootstrap/InputGroup';
import {Row,Col,Table} from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import CommonComponents from "./CommonComponents.js";
import { Rate , Divider, Input} from "rsuite";
import NewPost from "./AddImage.js"
import { Box, Dialog, DialogActions, DialogContent, DialogTitle,
     FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';

export const AddCashin=({setShowAddCashin,showAddCashin,currentCashin})=>{
 const [Cashin,setCashin] = useState(currentCashin!=null ? currentCashin :{
         id:null,
         entryDate: formatDate(new Date()),
         person:"",
         description:"",
         amount:0,
         expenseAmount:0,
         category:"",
         paymentMode:""
     })
     const totalAmount=4500;
    const url=process.env.REACT_APP_SERVER_URL;
    useEffect(() => {
      
    
    }, []);
    function handleCloseCashin(){
        setShowAddCashin(false);
    }

  




    return (
      <div>
        <React.Fragment>
      <Dialog
        open={showAddCashin}
        onClose={handleCloseCashin}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            handleCloseCashin();
          },
        }}
      >
        <DialogTitle>
            <Grid container spacing={2} >
            <Grid item xs={12} md={6}>Cash-in</Grid>
            <Grid item xs={12} md={6}> 
                <Grid container spacing={2} >
                                    <Grid item xs={12} md={4}></Grid>
                                    <Grid item xs={12} md={8}>$4,500</Grid>
                                </Grid>
                
            </Grid>
            </Grid>
        </DialogTitle>
        <DialogContent>
        <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
        <TextField
                        fullWidth
                    label="Amount"
                    sx={{ m: 1.2 }}
                    type="number"
                    value={Cashin.amount}
                    onChange={(e)=>setCashin((prev) => ({...prev, amount: e.target.value}))}
                    InputProps={{
                        startAdornment: <InputAdornment position="start" >$</InputAdornment>,
                    }}
                    InputLabelProps={{
                        sx: {
                        fontSize: "1rem", // Adjust font size
                        },
                    }}
                    variant="standard"
                    />

            </Grid>
            <Grid item xs={12} md={4}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} fullWidth>
        <InputLabel id="demo-simple-select-standard-label">Category</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={Cashin.category}
          onChange={(e)=>setCashin((prev) => ({...prev, category: e.target.value}))}
          label="Category"
        >
          <MenuItem value={"other"}>Other Income</MenuItem>
          <MenuItem value={"change"}>Change</MenuItem>
        </Select>
      </FormControl>

            </Grid>
            <Grid item xs={12} md={4}>
            <TextField
                        fullWidth
                    label="New Balance"
                    sx={{ m: 1.2 }}
                    type="number"
                    aria-readonly
                    value={totalAmount+ parseInt(Cashin.amount || 0)}
                    InputProps={{
                        startAdornment: <InputAdornment position="start" >$</InputAdornment>,
                    }}
                    InputLabelProps={{
                        sx: {
                        fontSize: "1rem", // Adjust font size
                        },
                    }}
                    variant="standard"
                    />

            </Grid>
            
        </Grid>
          
          
            
                
                    

                    
        
          <TextField
          fullWidth 
          sx={{ m: 1.2}}
          id="standard-textarea"
          label="Description"
          multiline
          variant="standard"
          value={Cashin.description}
          onChange={(e)=>setCashin((prev) => ({...prev, description: e.target.value}))}
          InputLabelProps={{
            sx: {
              fontSize: "1rem", // Adjust font size
            },
          }}
        />
        <label style={{color:"grey"}}>Cashin by Nikita Burton</label>

        
    
        
        
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCashin}>Cancel</Button>
          <Button type="submit">Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
        




 




      </div>
    );


}